import * as actionTypes from "../../Redux/Actions/actionTypes";

// File Upload Actions
export const uploadFile = (
  accountId,
  file,
  fileType,
  description,
  callback
) => ({
  type: actionTypes.FILE_UPLOAD_REQUEST,
  payload: { accountId, file, fileType, description, callback },
});

export const uploadFileSuccess = (response) => ({
  type: actionTypes.FILE_UPLOAD_SUCCESS,
  payload: response,
});

export const uploadFileError = (error) => ({
  type: actionTypes.FILE_UPLOAD_ERROR,
  payload: error,
});

// Get File List Actions
export const getFileList = (params, callback) => ({
  type: actionTypes.FILE_LIST_REQUEST,
  payload: { params, callback },
});

export const getFileListSuccess = (response) => ({
  type: actionTypes.FILE_LIST_SUCCESS,
  payload: response,
});

export const getFileListError = (error) => ({
  type: actionTypes.FILE_LIST_ERROR,
  payload: error,
});

// Download File Actions
export const downloadFile = (fileId, callback) => ({
  type: actionTypes.FILE_DOWNLOAD_REQUEST,
  payload: { fileId, callback },
});

export const downloadFileSuccess = (response) => ({
  type: actionTypes.FILE_DOWNLOAD_SUCCESS,
  payload: response,
});

export const downloadFileError = (error) => ({
  type: actionTypes.FILE_DOWNLOAD_ERROR,
  payload: error,
});

// Delete File Actions
export const deleteFile = (fileId, callback) => ({
  type: actionTypes.FILE_DELETE_REQUEST,
  payload: { fileId, callback },
});

export const deleteFileSuccess = (response) => ({
  type: actionTypes.FILE_DELETE_SUCCESS,
  payload: response,
});

export const deleteFileError = (error) => ({
  type: actionTypes.FILE_DELETE_ERROR,
  payload: error,
});

// Get File Stats Actions
export const getFileStats = (callback) => ({
  type: actionTypes.FILE_STATS_REQUEST,
  payload: { callback },
});

export const getFileStatsSuccess = (response) => ({
  type: actionTypes.FILE_STATS_SUCCESS,
  payload: response,
});

export const getFileStatsError = (error) => ({
  type: actionTypes.FILE_STATS_ERROR,
  payload: error,
});

// Clear File Management State
export const clearFileManagementState = () => ({
  type: actionTypes.CLEAR_FILE_MANAGEMENT_STATE,
});
